import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=1ce3a1e7&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&id=1ce3a1e7&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3a1e7",
  null
  
)

export default component.exports